import { render, staticRenderFns } from "./QuestionDetail.vue?vue&type=template&id=53f1f9c6&scoped=true"
import script from "./QuestionDetail.vue?vue&type=script&lang=js"
export * from "./QuestionDetail.vue?vue&type=script&lang=js"
import style0 from "./QuestionDetail.vue?vue&type=style&index=0&id=53f1f9c6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53f1f9c6",
  null
  
)

export default component.exports